module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-252.b3711cd8.svg";